import { BaseDto } from "src/dtos/common/baseDto";
/** 간이세액표 엔티티와 그리드 편집 상태이다. */
export interface HrmIncomeTaxTableDto extends BaseDto {
    applyYear: string; // 적용년도
    fromAmt: number; // 월급여 이상
    toAmt: number; // 월급여 미만
    tax1: number; // 가족 1명 세액
    tax2: number; // 가족 2명 세액
    tax3: number; // 가족 3명 세액
    tax4: number; // 가족 4명 세액
    tax5: number; // 가족 5명 세액
    tax6: number; // 가족 6명 세액
    tax7: number; // 가족 7명 세액
    tax8: number; // 가족 8명 세액
    tax9: number; // 가족 9명 세액
    tax10: number; // 가족 10명 세액
    tax11: number; // 가족 11명 세액
    remark: string; // 비고
    inserted: boolean; // true이면 신규 행
    isModified: boolean; // true이면 수정 행
}
/** 신규·빈 행에 사용하는 전체 기본값이다. */
export const defaultHrmIncomeTaxTableDto: HrmIncomeTaxTableDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    applyYear: '', fromAmt: 0, toAmt: 0,
    tax1: 0, tax2: 0, tax3: 0, tax4: 0, tax5: 0, tax6: 0, tax7: 0, tax8: 0, tax9: 0, tax10: 0, tax11: 0,
    remark: '', inserted: false, isModified: false,
};
